/**
 * @file components/biz/common/dialogAlertAction.js
 * @author zhangzhe(zhangzhe@baidu.com)
 */

// import {Modal} from 'acud';
// import _ from 'lodash';

import {DialogOption} from '../index';

export function dialogAlertAction(config: DialogOption, payload: any) {
    console.log(config, payload);
    // const {width, title, body, okText} = config;
    // const $title = _.template(title)(payload);
    // const alertMessage = _.template(body.content)(payload);

    // TODO acud 暂无
    // return new Promise((resolve, reject) => {
    //     Modal.info({
    //         title: $title,
    //         content: alertMessage,
    //         width: width || 416,
    //         okText: (okText || '确定'),
    //         centered: true,
    //         onOk: () => resolve(true),
    //         onCancel: () => reject()
    //     });
    // });
}
